import fx from "utils/fx";
import AxiosInterceptor from 'api/interceptor';

const shipper = new AxiosInterceptor();

export default {
  find(id) {
    return shipper.get('/shipper/' + id);
  },
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return shipper.get('/shipper?' + qstr);
  },
  create(inputs){
    return shipper.post('/shipper', inputs);
  },
  update(id, inputs){
    return shipper.put('/shipper/' + id, inputs);
  },
  delete(id){
    return shipper.delete('/shipper/' + id);
  }
};